import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { FilterNone } from '@material-ui/icons';
import { useToast } from '@redshelf/redshelf-ui';
import { isoStringDisplay } from 'utilities';
import { IconButton, IconTooltip } from 'components';
import {
  LabelForUserContentItems,
  UserContentCard,
} from 'components/UserContentCards';

const useStyles = makeStyles((theme) => {
  return {
    root: { border: 'none', borderRadius: '0' },

    highlight: {
      textDecoration: `underline ${theme.palette.greyBlue[700]} dashed`,
      textUnderlineOffset: `${theme.spacing(0.5)}px`,
    },
    hidden: {
      display: 'none',
    },
  };
});

const CopiedTextCard = ({ className, userContentItem, ...props }) => {
  const { bookLocation, dateCreated, id, page, snippet, truncatedSnippet } =
    userContentItem;

  const classes = useStyles();

  const { enqueueToast } = useToast();

  const handleCopyContent = () => {
    navigator.clipboard?.writeText(snippet);
    enqueueToast('Text copied!', {
      variant: 'success',
    });
  };

  const cardId = `copied-text-card-${id}`;
  const subheader = (
    <span className="noTranslate">{isoStringDisplay(dateCreated)}</span>
  );
  const title = page?.label ? (
    <>
      Page <span className="noTranslate">{page.label}</span>
    </>
  ) : (
    ''
  );
  const ariaLabelContent = (
    <>
      Copy Content <span className="noTranslate">{truncatedSnippet}</span> Again
    </>
  );

  return (
    <UserContentCard
      id={cardId}
      action={
        <>
          <div className={classes.hidden} id={`copy-again-${cardId}`}>
            {ariaLabelContent}
          </div>
          <IconTooltip id="copy-again" title="Copy Again">
            <IconButton
              aria-labelledby={`copy-again-${cardId}`}
              onClick={handleCopyContent}
            >
              <FilterNone />
            </IconButton>
          </IconTooltip>
        </>
      }
      bookLocation={bookLocation}
      classNames={{
        highlight: classes.highlight,
        root: clsx(classes.root, className),
      }}
      linkLabel={<LabelForUserContentItems userContentItem={userContentItem} />}
      snippet={truncatedSnippet}
      subheader={subheader}
      title={title}
      {...props}
    />
  );
};

CopiedTextCard.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  userContentItem: PropTypes.shape({}),
};

export default CopiedTextCard;
